<template>
  <div class="page mail">
    <div class="icon icon-circle1 abs"></div>
    <div class="icon icon-circle2 abs"></div>
    <div class="icon icon-mg-logo abs"></div>
    <div class="main">
      <div class="icon icon-logo2"></div>
      <p class="sub-title">电子邮件永远不会沾上泪水，唯有书写疗愈烦恼</p>
      <p class="main-title">《朋友请听好》第二季信件招募</p>
      <div class="pannel">
        <div class="pannel-content">
          <p>收信地址：</p>
          <p>湖南省长沙市开福区芒果TV</p>
          <p>《朋友请听好》栏目组13397499705</p>
        </div>
      </div>
      <p style="text-align: left">
        给广播小站分享故事的信、给小秘密一个藏身之处的信、给未来的自己的信、给故去亲人的信、给擦肩而过的陌生人的信、给宠物的信……无论你想寄给谁，统统可以寄到这里。
      </p>
      <div class="icon icon-mg-logo abs"></div>
      <div class="line-wrapper">
        <div class="icon icon-line2"></div>
        <div class="icon icon-cat abs"></div>
      </div>
      <div class="">
        <p>注意事项：</p>
        <p>①请大家不要寄礼物，收到你的来信就是我们最开心的事情</p>
        <p>②寄出的信件请务必在信封上留下你的通信地址和联系方式</p>
        <p>③来信内容不限，你的烦恼，你的快乐，我们愿意倾听一切</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {}
};
</script>

<style lang="scss">
@import "~@/assets/mixins.scss";

.mail {
  .main {
    @include px2vw(padding-top, 60);
    @include px2vw(width, 690);
    margin: 0 auto;
    color: #333333;
    text-align: center;
    @include px2vw(font-size, 24);
    @include px2vw(line-height, 33);
  }

  .main-title {
    font-weight: 500;
    @include px2vw(line-height, 50);
    @include px2vw(font-size, 36);
  }
  .sub-title {
    font-weight: 500;
    @include px2vw(line-height, 40);
    @include px2vw(font-size, 28);
    @include px2vw(margin-top, 40);
    @include px2vw(margin-bottom, 20);
  }

  .icon {
    &-line2 {
      margin: 0 auto;
      @include px2vw(margin-top, 33);
      @include px2vw(margin-bottom, 75);
    }
    &-logo {
      @include px2vw(top, 20);
      @include px2vw(left, 30);
    }
    &-logo2 {
      margin: 0 auto;
    }
    &-mg-logo {
      @include px2vw(top, 20);
      @include px2vw(left, 30);
    }
    &-cat {
      @include px2vw(bottom, 0);
      @include px2vw(right, 0);
      transform: translateY(100%);
    }
    &-paper {
      @include px2vw(top, -30);
      @include px2vw(left, -75);
      transform: translateX(-100%);
    }
  }

  .line-wrapper {
    position: relative;
  }
  .pannel {
    &-wrapper {
      @include px2vw(padding-top, 195);
      @include px2vw(line-height, 40);
    }
    &-tip {
      @include px2vw(padding-top, 50);
      @include px2vw(padding-bottom, 75);
      font-weight: 400;
      letter-spacing: 2px;
      text-align: center;
    }
    &-content {
      font-weight: 500;
      text-align: center;
      @include px2vw(line-height, 42);
      @include px2vw(font-size, 30);
      p:first-child {
        @include px2vw(font-size, 34);
        @include px2vw(margin-bottom, 24);
      }
    }
    position: relative;
    background-image: url("~@/assets/img/panel-2.png");
    @include px2vw(width, 610);
    @include px2vw(height, 315);
    @include px2vw(padding-top, 57);
    margin: 0 auto;
    @include px2vw(margin-top, 40);
    @include px2vw(margin-bottom, 40);
  }
}

</style>
